import { render, staticRenderFns } from "./DefaultServiceType.vue?vue&type=template&id=9f7ad45c&"
import script from "./DefaultServiceType.vue?vue&type=script&lang=js&"
export * from "./DefaultServiceType.vue?vue&type=script&lang=js&"
import style0 from "./DefaultServiceType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports